/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListTemplateRequest } from '../../models/api-response-list-template-request';

export interface ListTemplateRequests$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listTemplateRequests(http: HttpClient, rootUrl: string, params: ListTemplateRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTemplateRequest>> {
  const rb = new RequestBuilder(rootUrl, listTemplateRequests.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListTemplateRequest>;
    })
  );
}

listTemplateRequests.PATH = '/v1/api/ui/template-request/list';
